import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './MonitoringCenterSettingsPanel.module.scss';
import MonitoringCenterSettingsModal from './MonitoringCenterSettingsModal';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';
import { useCustomSettingsContext } from '../../../CustomSettings/Services/CustomSettingsContext';

interface Props {
	customSettingKey: CustomSettingKey;
}

const MonitoringCenterSettingsPanel: React.FC<Props> = ({
	customSettingKey,
}) => {
	const [isSettingOpen, setIsSettingOpen] = useState(false);
	const { refetchCustomSettings } = useCustomSettingsContext();

	const onSettingSave = async () => {
		setIsSettingOpen(false);
		await refetchCustomSettings();
	};

	return (
		<div className={styles.wrapper}>
			<LinkButton
				title='component.monitoringCenterSettings.title'
				theme={Theme.BLUE}
				onClick={() => setIsSettingOpen(true)}
			/>
			{isSettingOpen && (
				<MonitoringCenterSettingsModal
					customSettingKey={customSettingKey}
					isOpen
					onClose={() => setIsSettingOpen(false)}
					onSave={onSettingSave}
				/>
			)}
		</div>
	);
};

export default MonitoringCenterSettingsPanel;
